<template>
    <navbar />
    <div class="works">
        <div class="container">
            <div class="row">
                <projectCard v-for="(project, index) in projects" :key="index" :project="project" />
            </div>
        </div>
    </div>
    <Footer />
</template>

<script>
import navbar from '@/components/layout/navbar.vue';
import projectCard from '@/components/include/cards/projectCard.vue';
import Footer from '@/components/layout/footer.vue';
import axios from 'axios'

export default {
    name: 'Work-page',
    data() {
        return {
            projects: []
        }
    },
    components: {
        navbar,
        projectCard,
        Footer
    },
    methods: {
        fetchProjects() {
            axios
              .get("/fetch_all_projects")
              .then(({ data }) => {
                this.projects = data.data;
                // console.log(this.meals , "meals");
            })
            .catch((error) => {
                return error
            });
        },
    },
    created() {
        this.fetchProjects();
    }
}
</script>

<style>

</style>